export default __webpack_public_path__ + "static/media/dots-corner.6f80b0d7.svg";